import { Tooltip, Typography } from '@mui/material';
import React from 'react';

const LabelCell = React.memo(({ label }: { label: string }) => {
  // const lastLabel = label.split('|').at(-1);
  // const filterLabel = lastLabel?.toLowerCase().includes('quote') ? 'Last Baseline' : lastLabel;

  const filterLabel = label
    ?.split('|')
    .map((part) => (part.trim().toLowerCase() === 'quote' ? 'LastBaseline' : part))
    .join(' , ');

  return (
    <Tooltip arrow title={filterLabel}>
      <Typography variant="body2" noWrap>
        {filterLabel}
      </Typography>
    </Tooltip>
  );
});

export default LabelCell;
